<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent2"><a id="ch00_fm02"></a><a id="page_ii"></a><span class="small"><strong>THE HISTORY OF DISABILITY</strong></span></p>
<p class="noindent">A series edited by Paul K. Longmore and Lauri Umansky</p>
<p class="noindent1"><em>The New Disability History: American Perspectives</em><br/>Edited by Paul K. Longmore and Lauri Umansky</p>
<p class="noindent1"><em>Reflections: The Life and Writings of a Young Blind Woman</em><br/><em>in Post-Revolutionary France</em><br/>Thérèse-Adèle Husson<br/>Edited and translated by<br/>Catherine J. Kudlick and Zina Weygand</p>
<p class="noindent1"><em>Signs of Resistance: American Deaf Cultural History,<br/>1900 to World War II</em><br/>Susan Burch</p>
<p class="noindent1"><em>The Radical Lives of Helen Keller</em><br/>Kim E. Nielsen</p>
<p class="noindent1"><em>Mental Retardation in America: A Historical Reader</em><br/>Edited by Steven Noll and James W. Trent, Jr.</p>
<p class="noindent1"><em>Helen Keller: Selected Writings</em><br/>Edited by Kim E. Nielsen</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02.vue?5f6adaa9